import { toSnakeCase } from "../../../../helpers";
import Tabs from "../../../../components/elements/Tabs";
import { useTranslation } from "react-i18next";
import List from "../../../../components/sections/admin/user/List";
import PrivacyAndSecurity from "../../../../components/sections/admin/user/PrivacyAndSecurity";
import BulkUploadUser from "../../../../components/sections/admin/user/BulkUploadUser";
import CustomAttributes from "../../../../components/sections/admin/user/CustomAttributes";
import NotFoundPage from "../../../../components/common/NotFoundPage";
import { useTabQuery } from "../../../../hooks/useTabQuery";
import { useMemo } from "react";
import { setTitle } from "../../../../helpers/MetaTag";

const Users = () => {
  const { t } = useTranslation();
  setTitle("User Management");
  const tabs = useMemo(
    () => [
      {
        label: "User List",
        icon: "fa-light fa-user",
        content: <List />,
        key: "user-list",
      },
      // {
      //   label: "Custom Attributes",
      //   icon: "fa-light fa-gear",
      //   type: "image",
      //   content: <CustomAttributes />,
      //   key: "custom-attributes",
      // },
      // {
      //   label: "Privacy & Security",
      //   icon: "fa-light fa-fingerprint",
      //   type: "image",
      //   content: <PrivacyAndSecurity />,
      //   key: "privacy-security",
      // },
      // {
      //   label: "Bulk Import",
      //   icon: "fa-light fa-file-import",
      //   type: "image",
      //   content: <BulkUploadUser />,
      //   key: "bulk-import",
      // },
    ],
    [],
  );

  const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

  if (!validTab) {
    return <NotFoundPage link="/admin/users?tab=user-list" />;
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-6">
        <div className="font-normal text-lg xl:text-3xl text-primary">
          {t(toSnakeCase("user management"))}
        </div>
        <Tabs
          items={tabs}
          selectedIndex={selectedIndex}
          setSelectedIndex={handleTabChange}
        />
      </div>
    </div>
  );
};

export default Users;
